import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  activityNodeMapAtom,
  destinationTreeAtom,
  destTreeIdMap,
  sourceTreeAtom,
} from './atoms'
import { FilterType, NodeFilterType } from '../treeManipulation/types'
import { NodeType } from 'shared/types/ingestion'
import { getFilteredResults } from '../treeManipulation/getFilteredResults'
import { INode } from 'shared/types/tree'
import {
  getNodeUpdates,
  getVerifiedQuestionCounts,
  hasQuestions,
} from './utility'
import { useCallback } from 'react'

const activityAndAssessmentFilter: NodeFilterType = {
  filterType: FilterType.node,
  typeSelections: {
    filterType: 'including',
    types: [NodeType.Activity, NodeType.Assessment],
  },
}

export function getActivityNodes(tree: INode, filterNoQuestions: boolean) {
  const activities = getFilteredResults(
    activityAndAssessmentFilter,
    tree,
  ) as INode[]
  if (filterNoQuestions) {
    return activities.filter((activity) => hasQuestions(activity))
  }
  return activities
}

export function getActivityNodeIds(tree: INode, filter: boolean) {
  return getActivityNodes(tree, filter).map(({ id }) => id)
}

export function useFilteredDestinationNodes() {
  const { tree } = useAtomValue(destinationTreeAtom)
  if (!tree) return []
  return getActivityNodeIds(tree, false)
}

export function useFilteredSourceNodes() {
  const tree = useAtomValue(sourceTreeAtom)
  if (!tree) return []
  return getActivityNodeIds(tree, true)
}

export function useGetVerifiedQuestionCount() {
  const destIdMap = useAtomValue(destTreeIdMap)
  const nodeMapping = useAtomValue(activityNodeMapAtom)

  return useCallback(
    (destinationNodeId: string): boolean | undefined => {
      return getVerifiedQuestionCounts(
        destinationNodeId,
        destIdMap,
        nodeMapping,
      )
    },
    [destIdMap, nodeMapping],
  )
}

export function useUpdatesForActivityId(...destinationNodeId: string[]) {
  const destIdMap = useAtomValue(destTreeIdMap)
  const nodeMapping = useAtomValue(activityNodeMapAtom)

  if (!destIdMap) return []
  const getUpdates = (destinationNodeId: string) => {
    const { node: destActivityNode } = destIdMap[destinationNodeId]
    const sourceActivityNode = nodeMapping[destinationNodeId][0]
    return getNodeUpdates({ destActivityNode, sourceActivityNode })
  }
  return destinationNodeId.flatMap(getUpdates)
}
